<template>
  <b-row>
    <b-col>
      <div class="club-group">
        <div
          v-for="tid in orderTypeIds"
          :key="tid"
          :class="{ selected: selectedOrderTypeComputed === tid, duplicate: hasDuplicates(tid) }"
          class="club-card"
          @click="selectedOrderTypeComputed = tid">
          <div class="club-card-inner">
            <AImage
              :img="orderTypes[tid].image"
              preset="wineclubteaser"
              responsive
              contain
              class="club-card-image"
            />
            <div class="club-card-content">
              <div class="title">
                <h3>{{ orderTypes[tid].title }}</h3>
              </div>
              <div
                v-if="!hasDuplicates(tid)"
                class="description"
                v-html="formatedHtml(orderTypes[tid].abstract)"
              />
              <div
                v-else
                class="duplicate-error"
              >
                <strong>WARNING:</strong> This cannot be used as {{ numDuplicates(tid) }} entries exist. Please contact the admin.
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'

export default {
  name: 'order-type-step',
  computed: {
    selectedOrderTypeComputed: {
      get () {
        return this.selectedOrderType
      },
      set (val) {
        if (!this.hasDuplicates(val)) {
          this.SET_SELECTED_ORDER_TYPE(val);
        }
      }
    },
    orderTypeIds () {
      return Object.keys(this.orderTypes).reduce((acc, id) => {
        if (
          this.orderTypes[id].visibility.length === 0 ||
          this.$store.getters['user/userid'] === '1' ||
          this.$store.getters['user/hasAnyRole'](this.orderTypes[id].visibility.map(data => data.role))
        ) {
          // Check visibility on frequencies and quantities
          if (this.$store.getters['user/userid'] !== '1') {
            freqLoop: for (const freq of Object.values(this.orderTypes[id].frequencies)) {
              for (const quant of Object.values(freq.quantities)) {
                if (quant.visibility.length === 0 || this.$store.getters['user/hasAnyRole'](quant.visibility.map(data => data.role))) {
                  acc.push({ order: this.orderTypes[id].order, tid: id })
                  break freqLoop
                }
              }
            }
          }
          else {
            acc.push({ order: this.orderTypes[id].order, tid: id })
          }
        }
        return acc
      }, []).sort((a, b) => a.order - b.order ).map(item => item.tid)
    },
    ...mapState('somnambulistui', ['orderTypes', 'selectedOrderType', 'orderId'])
  },
  methods: {
    ...mapMutations('somnambulistui', ['SET_SELECTED_ORDER_TYPE']),
    formatedHtml (escapedHtml) {
      return escapedHtml.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    },
    hasDuplicates(id) {
      return !!this.orderTypes[id].__duplicate;
    },
    numDuplicates(id) {
      return this.orderTypes[id].__numDuplicates;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

</style>
